module.exports = __webpack_public_path__ + "static/media/pic13.5e00e5ec.jpg";